import { observer } from 'mobx-react-lite';

import { ViewTable } from '@/configs/ViewTable';
import { DateNavigationModel } from '@/models/DateNavigationModel';

import { DatePicker } from './DatePicker';
import type { SyncConfig } from './SyncButton';
import { SyncButton } from './SyncButton';

import s from './TimesheetControls.module.scss';

type TimesheetControlsProps = {
  dateNavigation: DateNavigationModel;
  allowedViews?: ViewTable[];
  syncConfig: SyncConfig;
  viewerChildren?: React.ReactNode;
  leftActionsChildren?: React.ReactNode;
  actionsChildren?: React.ReactNode;
};

const TimesheetControls: React.FC<TimesheetControlsProps> = observer(
  ({
    dateNavigation,
    allowedViews,
    syncConfig,
    viewerChildren,
    leftActionsChildren,
    actionsChildren,
  }) => {
    return (
      <div className={s.controls}>
        <DatePicker dateNavigation={dateNavigation} allowedViews={allowedViews}>
          <SyncButton config={syncConfig} />
          {viewerChildren}
        </DatePicker>

        {leftActionsChildren && (
          <div className={s['controls__left-actions']}>{leftActionsChildren}</div>
        )}
        {actionsChildren && <div className={s.controls__actions}>{actionsChildren}</div>}
      </div>
    );
  },
);

export { TimesheetControls };
